import { useEffect, useRef } from "react";
import {
  handlePostApiGF,
  isIOS,
  Toast,
  Userlogin,
} from "../Component/Utils/general-function";
// import { onForegroundNotificationListner } from "../firebase/Firebase-Configuration";
import { toast } from "react-toastify";

const NotificationHandler = () => {
  const initializedRef = useRef(false);

  const sendDeviceToken = async () => {
    const { requestForToken } =
      await import("../firebase/Firebase-Configuration"); // dynamic import here otherwise ios react native throw error bcz firebase sdk not supported

    const token = await requestForToken();
    if (!token) return;

    let storedToken = sessionStorage.getItem("deviceToken");
    if (storedToken === token) return;
    sessionStorage.setItem("deviceToken", token);

    let obj = {
      nDevicetype: isIOS() ? "ios" : "android",
      nDeviceid: token,
    };
    const res = await handlePostApiGF({
      url: "/api/AddDivicelog/AddDevicelogdetails",
      obj,
    });
    console.log("res device token", res);

    if (!res?.succ) {
      sessionStorage.removeItem("deviceToken");
      Toast(false, "", "Failed to Send Device Token");
    }
  };

  useEffect(() => {
    if (initializedRef.current) return;
    if (isIOS() || !Userlogin()) return;

    initializedRef.current = true;

    Notification.requestPermission()
      .then(async (permission) => {
        if (permission === "granted") {
          sendDeviceToken();
        } else {
          console.info("Notification permission denied");
        }
      })
      .catch((err) => {
        console.error("Catch: Notification permission error:", err);
      });

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then(() => {
          console.log("firebase service worker registration is successfully");
        })
        .catch((err) => {
          console.error("firebase service worker registration failed", err);
        });
    }
  }, []);

  useEffect(() => {
    if (isIOS()) return;
    let unsubscribe = () => {};
    (async () => {
      const { onForegroundNotificationListner } =
        await import("../firebase/Firebase-Configuration");

      // const messaging = await initMessaging();
      // if (!messaging) return;

      unsubscribe = onForegroundNotificationListner((payload) => {
        console.log("payload", payload);

        const { title, body, image } = payload.data || {};
        if (!title && !body) return () => {};

        toast(
          <div className="w-100">
            <div
              style={{
                display: "flex",
                gap: 10,
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <img
                src="https://m.carthi.in/assets/images/logo.png"
                alt=""
                height={20}
              />
              <span
                style={{
                  color: "#000",
                  fontWeight: "bold",
                  cursor: "pointer",
                  marginLeft: "auto",
                }}
              >
                ✕
              </span>
            </div>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              {image && (
                <img
                  src={image}
                  alt=""
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 6,
                    objectFit: "cover",
                  }}
                />
              )}
              <div>
                {title && <div style={{ fontWeight: 600 }}>{title}</div>}
                {body && (
                  <div
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 10,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      fontSize: 13,
                    }}
                  >
                    {body}
                  </div>
                )}
              </div>
            </div>
          </div>,
          {
            position: "top-center",
            autoClose: 10000,
            style: {
              background: "#fff",
              color: "#000",
              padding: "10px",
            },
          },
        );
      });
    })();

    return () => unsubscribe(); // cleanup
  }, []);
};

export default NotificationHandler;

// old code with crashed on ios
// import React, { useEffect, useRef } from "react";
// import {
//   handlePostApiGF,
//   isIOS,
//   Toast,
//   Userlogin,
// } from "../Component/Utils/general-function";
// import { onForegroundNotificationListner } from "../firebase/Firebase-Configuration";
// import { toast } from "react-toastify";

// const NotificationHandler = () => {
//   const initializedRef = useRef(false);

//   const sendDeviceToken = async () => {
//     const { requestForToken } = await import(
//       "../firebase/Firebase-Configuration"
//     ); // dynamic import here otherwise ios react native throw error bcz firebase sdk not supported

//     const token = await requestForToken();
//     // let token;
//     console.log("token", token);

//     let storedToken = sessionStorage.getItem("deviceToken");
//     if (storedToken === token) return;
//     sessionStorage.setItem("deviceToken", token);

//     let obj = {
//       nDevicetype: isIOS() ? "ios" : "android",
//       nDeviceid: token,
//     };
//     const res = await handlePostApiGF({
//       url: "/api/AddDivicelog/AddDevicelogdetails",
//       obj,
//     });
//     console.log("res device token", res);

//     if (!res?.succ) {
//       sessionStorage.removeItem("deviceToken");
//       Toast(false, "", "Failed to Send Device Token");
//     }
//   };

//   useEffect(() => {
//     if (!initializedRef.current) {
//       if (isIOS() || !Userlogin()) return;
//       initializedRef.current = true;

//       Notification.requestPermission()
//         .then(async (permission) => {
//           if (permission === "granted") {
//             sendDeviceToken();
//           } else {
//             console.info("Notification permission denied");
//           }
//         })
//         .catch((err) => {
//           console.error("Catch: Notification permission error:", err);
//         });

//       if ("serviceWorker" in navigator) {
//         navigator.serviceWorker
//           .register("/firebase-messaging-sw.js")
//           .then(() => {
//             console.log("firebase service worker registration is successfully");
//           })
//           .catch((err) => {
//             console.error("firebase service worker registration failed", err);
//           });
//       }
//     }
//   }, []);

//   useEffect(() => {
//     const unsubscribe = onForegroundNotificationListner((payload) => {
//       const { title, body, image } = payload.data || {};

//       toast(
//         <div className="w-100">
//           <div
//             style={{
//               display: "flex",
//               gap: 10,
//               alignItems: "center",
//               justifyContent: "space-between",
//               width: "100%",
//             }}
//           >
//             <img
//               src="https://m.carthi.in/assets/images/logo.png"
//               alt=""
//               height={20}
//             />
//             <span
//               style={{
//                 color: "#000",
//                 fontWeight: "bold",
//                 cursor: "pointer",
//                 marginLeft: "auto",
//               }}
//             >
//               ✕
//             </span>
//           </div>
//           <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
//             {image && (
//               <img
//                 src={image}
//                 alt=""
//                 style={{
//                   width: 40,
//                   height: 40,
//                   borderRadius: 6,
//                   objectFit: "cover",
//                 }}
//               />
//             )}
//             <div>
//               {title && <div style={{ fontWeight: 600 }}>{title}</div>}
//               {body && (
//                 <div
//                   style={{
//                     display: "-webkit-box",
//                     WebkitLineClamp: 10,
//                     WebkitBoxOrient: "vertical",
//                     overflow: "hidden",
//                     fontSize: 13,
//                   }}
//                 >
//                   {body}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>,
//         {
//           position: "top-center",
//           autoClose: 10000,
//           style: {
//             background: "#fff",
//             color: "#000",
//             padding: "10px",
//           },
//         }
//       );
//     });

//     return () => unsubscribe(); // cleanup
//   }, []);
// };

// export default NotificationHandler;
